import { render, staticRenderFns } from "./c-patient-general-setting-form.vue?vue&type=template&id=71ae024d&"
import script from "./c-patient-general-setting-form.vue?vue&type=script&lang=js&"
export * from "./c-patient-general-setting-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports